export class HelpLinkReq {
    type:string;
    frequency:string;
    description:string;
}

export class HelpLinkRes {
    Message:string
}